const formatName = (name = '') =>
  name.toLowerCase().replace(/(\b[a-z](?!\s))/g, x => x.toUpperCase());

export default formatName;
